import React from "react";
import { motion } from "framer-motion";

export interface MiniTab {
  key: string;
  label: string;
  icon: React.ReactNode;
}

interface MiniTabBarProps {
  tabs: MiniTab[];
  activeTab: string;
  onTabChange: (key: string) => void;
  layoutId: string;
}

const MiniTabBar: React.FC<MiniTabBarProps> = ({
  tabs,
  activeTab,
  onTabChange,
  layoutId,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 mb-6">
      <div className="flex border-b border-slate-200 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className="relative flex items-center gap-2 px-6 py-4 text-sm font-medium transition-colors whitespace-nowrap"
            style={{
              color: activeTab === tab.key ? "var(--color-primary)" : "#64748b",
            }}
          >
            {tab.icon}
            {tab.label}
            {activeTab === tab.key && (
              <motion.div
                layoutId={layoutId}
                className="absolute bottom-0 left-0 right-0 h-0.5"
                style={{ backgroundColor: "var(--color-primary)" }}
                transition={{ type: "spring", stiffness: 500, damping: 30 }}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MiniTabBar;
